import {PageableModel} from "../../common/models/table";
import {AxiosResponse} from "axios";
import {Api, apiUrls} from "../../helpers/api";
import http from "../../common/services/httpService";
import {ReportFileFormat} from "../models/reportFileFormatEnum";
import {DownloadService} from "../../common/services/downloadService";
import {TrailerBaseModel, TrailerBaseFilters} from "../models/trailerBase";

export class TrailerBaseService {
    private static baseUrl = apiUrls.reports.trailerBase;

    public static async generateReport(filters: TrailerBaseFilters): Promise<AxiosResponse<PageableModel<TrailerBaseModel>>> {
        const url = Api.getUrl(this.baseUrl);

        return await http.get<PageableModel<TrailerBaseModel>>(
            `${Api.addParams(url, this.getParams(filters))}`
        );
    }

    public static async download(filters: TrailerBaseFilters, fileFormat: ReportFileFormat): Promise<AxiosResponse> {
        const mediaType = fileFormat === ReportFileFormat.xls ? "application/xls" : "application/csv";

        return DownloadService.download(this.baseUrl, mediaType, this.getParams(filters));
    }

    private static getParams(filters: TrailerBaseFilters) {
        return `depoEntryDateFrom=${filters.depoEntryDateFrom}&depoEntryDateTo=${filters.depoEntryDateTo}` +
            `&depoExitDateFrom=${filters.depoExitDateFrom}&depoExitDateTo=${filters.depoExitDateTo}` +
            `&bookingDateFrom=${filters.bookingDateFrom}&bookingDateTo=${filters.bookingDateTo}` +
            `&cargoType=${filters.cargoType}&shipperId=${filters.shipperId}&paymentWaiver=${filters.paymentWaiver}` +
            `&ferryEntityId=${filters.ferryEntityId}&relationType=${filters.relationType}&voyageNo=${filters.voyageNo}`;
    }
}
